// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> sunrise-management-preferred -> the-fletcher
// Generated: 2026-10-20T17:35:55.429Z
// Counts: 1 design, 61 content, 14 slot group, 5 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our one and two-bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability And Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>1 &amp; 2 Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Property Photos</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": "entrata",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": "<p>See what life at <span data-type=\"field-token\" data-field=\"property_name\"></span> is all about.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life is easier at The Fletcher.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Fletcher in La Mesa, CA, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Ready to envision your new home? Schedule a tour today and see what our residents cherish most about living in our welcoming community!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019e98bf-477e-71e1-b972-a962beba443a.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167024/019d08bd-c531-75e4-a36a-843ab9f30a8d.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019eba3f-26ff-75dc-b1cf-f67bf61ac33b.webp"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sunrise Management logo"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019fa9ce-582c-735d-a708-6bc87f11199e.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Young man happily playing with his dalmatian dog on a wooden floor indoors."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019edeba-1931-773f-a319-2798c347c86e.webp"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019fa9d1-ec2a-7298-8858-a9e7aed45894.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A diverse group of friends waving and having fun at a lively summer pool party."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 27,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_9bf90a0e05162816dc9e8705",
      "ec_62e725e28f846a7a52546afd",
      "ec_a491ce0dfe8e2927a31f29c5",
      "ec_061438b39218d0c410494a1a",
      "ec_b2a25f3bf2a69431ae6397a0",
      "ec_f905b1ec6c5264db8f54bc33",
      "ec_5b661f5071425e63a82c96f7",
      "ec_eedd1ef4e6385e46df020088",
      "ec_ca347dd29fa3b6607ad35e18",
      "ec_e1d153f2dee8bd1b99fa52ba",
      "ec_cbf4943e44ce89e1e28deaf5",
      "ec_4335867ff7a252fe4b83745e",
      "ec_12617de7ea3b300c7fda0bf1",
      "ec_ed4f607598f1f0845a352366",
      "ec_ab5e226e995c9d0fec7537ff",
      "ec_e143676b04322d8340232764",
      "ec_51546403da56f5e770b96dea",
      "ec_cd4d4d43d621be698f94cd42",
      "ec_4d4eadd2089140235ede934a",
      "ec_3a8e4c32fb5f7c7be68ee392",
      "ec_a1fb4ead295a7ed1dfafe521",
      "ec_215b72ad265e4aa658f4a9f6",
      "ec_f1174dd6f4441eaf84ff06e9",
      "ec_4de0a023b29bfecf264f2a6f",
      "ec_115e9d789921c957b6b8a1e7",
      "ec_b348b814db30e92e82d8be9a",
      "ec_458308a06a2fc49042d8e1d2",
      "ec_a578700c036c4bb541f6f037",
      "ec_faf9b9bc02a5efb0ab70d372",
      "ec_1f59d33c876c9a62d2c88141",
      "ec_9bcc60e9528332a5898ebb87",
      "ec_005ca0906998878fa872765b",
      "ec_58384b42b6420f3b8635c8a1",
      "ec_c06892ea6cca6c9be7783c7c",
      "ec_938b3907b2d608ce87ef35e4",
      "ec_86d6994d496b22228be32b16",
      "ec_52b147c8686ebcf477c62505",
      "ec_ad3bcff873a309957108b303",
      "ec_4dca7c8257390af00b087c42",
      "ec_8b1319d360fbda025c024002",
      "ec_6b7ba853f65f67af373cd6ab",
      "ec_104105be2956d52af49629ef",
      "ec_2857b51f7b5032a6d7747741",
      "ec_d8da84f196d3996191de675a"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "ec_12617de7ea3b300c7fda0bf1",
      "ec_ab5e226e995c9d0fec7537ff",
      "ec_ed4f607598f1f0845a352366",
      "ec_e143676b04322d8340232764",
      "ec_51546403da56f5e770b96dea",
      "ec_cd4d4d43d621be698f94cd42",
      "ec_a1fb4ead295a7ed1dfafe521",
      "ec_3a8e4c32fb5f7c7be68ee392",
      "ec_4d4eadd2089140235ede934a",
      "ec_215b72ad265e4aa658f4a9f6",
      "ec_f1174dd6f4441eaf84ff06e9",
      "ec_115e9d789921c957b6b8a1e7",
      "ec_a578700c036c4bb541f6f037",
      "ec_458308a06a2fc49042d8e1d2",
      "ec_b348b814db30e92e82d8be9a",
      "ec_faf9b9bc02a5efb0ab70d372",
      "ec_1f59d33c876c9a62d2c88141"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_1f59d33c876c9a62d2c88141",
      "ec_a578700c036c4bb541f6f037",
      "ec_3a8e4c32fb5f7c7be68ee392",
      "ec_cd4d4d43d621be698f94cd42",
      "ec_458308a06a2fc49042d8e1d2",
      "ec_215b72ad265e4aa658f4a9f6",
      "ec_b348b814db30e92e82d8be9a",
      "ec_faf9b9bc02a5efb0ab70d372",
      "ec_ab5e226e995c9d0fec7537ff",
      "ec_e143676b04322d8340232764",
      "ec_ed4f607598f1f0845a352366",
      "ec_a1fb4ead295a7ed1dfafe521",
      "ec_4d4eadd2089140235ede934a",
      "ec_115e9d789921c957b6b8a1e7",
      "ec_f1174dd6f4441eaf84ff06e9",
      "ec_51546403da56f5e770b96dea",
      "ec_12617de7ea3b300c7fda0bf1",
      "ec_5b661f5071425e63a82c96f7",
      "ec_4335867ff7a252fe4b83745e"
    ],
    "orderedIds": [
      "ec_e1d153f2dee8bd1b99fa52ba",
      "ec_cbf4943e44ce89e1e28deaf5",
      "ec_ca347dd29fa3b6607ad35e18",
      "ec_52b147c8686ebcf477c62505",
      "ec_6b7ba853f65f67af373cd6ab",
      "ec_2857b51f7b5032a6d7747741",
      "ec_104105be2956d52af49629ef",
      "ec_d8da84f196d3996191de675a",
      "ec_005ca0906998878fa872765b",
      "ec_58384b42b6420f3b8635c8a1",
      "ec_c06892ea6cca6c9be7783c7c",
      "ec_4335867ff7a252fe4b83745e",
      "ec_938b3907b2d608ce87ef35e4",
      "ec_86d6994d496b22228be32b16",
      "ec_ad3bcff873a309957108b303",
      "ec_eedd1ef4e6385e46df020088",
      "ec_9bcc60e9528332a5898ebb87",
      "ec_8b1319d360fbda025c024002",
      "ec_4dca7c8257390af00b087c42",
      "ec_9bf90a0e05162816dc9e8705",
      "ec_62e725e28f846a7a52546afd",
      "ec_a491ce0dfe8e2927a31f29c5",
      "ec_061438b39218d0c410494a1a",
      "ec_f905b1ec6c5264db8f54bc33",
      "ec_b2a25f3bf2a69431ae6397a0",
      "ec_5b661f5071425e63a82c96f7",
      "ec_12617de7ea3b300c7fda0bf1",
      "ec_115e9d789921c957b6b8a1e7",
      "ec_f1174dd6f4441eaf84ff06e9",
      "ec_51546403da56f5e770b96dea",
      "ec_4d4eadd2089140235ede934a",
      "ec_a1fb4ead295a7ed1dfafe521",
      "ec_ed4f607598f1f0845a352366",
      "ec_faf9b9bc02a5efb0ab70d372",
      "ec_ab5e226e995c9d0fec7537ff",
      "ec_e143676b04322d8340232764",
      "ec_b348b814db30e92e82d8be9a",
      "ec_215b72ad265e4aa658f4a9f6",
      "ec_458308a06a2fc49042d8e1d2",
      "ec_a578700c036c4bb541f6f037",
      "ec_3a8e4c32fb5f7c7be68ee392",
      "ec_cd4d4d43d621be698f94cd42",
      "ec_1f59d33c876c9a62d2c88141"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "entrata-chatbot",
      "blockId": "entrata-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
